<template>
  <div id="app">
    <router-view />
    <gallery-highlight />
  </div>
</template>

<script>
import GalleryHighlight from '@/components/GalleryHighlight'

export default {
  name: 'App',
  components: {
    GalleryHighlight
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'SuisseIntl-Regular';
  src: url('./assets/fonts/SuisseIntl-Regular-WebM.woff2') format('woff2'),
       url('./assets/fonts/SuisseIntl-Regular-WebM.woff') format('woff'),
       url('./assets/fonts/SuisseIntl-Regular-WebM.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SuisseIntl-Regular';
  src: url('./assets/fonts/SuisseIntl-RegularItalic-WebM.woff2') format('woff2'),
       url('./assets/fonts/SuisseIntl-RegularItalic-WebM.woff') format('woff'),
       url('./assets/fonts/SuisseIntl-RegularItalic-WebM.ttf') format('truetype');
  font-weight: normal;
  font-style: italic;
}

body {
  background-color: $background;
}

#app {
  font-family: 'SuisseIntl-Regular', Arial, Helvetica, sans-serif;
  min-height: 100vh;
  background-color: $background;

  @media screen and (max-width: $mobile) {
    min-height: 100%;
  }
}
</style>
